import axios from "axios";

const api = axios.create({
  baseURL: "/api"
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (
      config.url?.startsWith("/public") ||
      config.url?.startsWith("/auth")
    ) {
      return config;
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

let logoutTriggered = false;

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url;

    if (
      (status === 401 || status === 403) &&
      !url?.startsWith("/public") &&
      !logoutTriggered
    ) {
      logoutTriggered = true;
      window.dispatchEvent(new Event("logout"));
    }

    return Promise.reject(error);
  }
);

export default api;